var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.tableDataStyle),function(item,index){return _c('div',{key:item.intitleStyleId,staticClass:"style-outer",on:{"click":function($event){return _vm.babyNameConnet(item)}}},[_c('div',{staticClass:"isCheck"},[_c('i',{class:[
          'el-icon-success',
          { active_class: _vm.activeIndex == item.intitleStyleId },
        ]})]),_c('el-image',{staticStyle:{"width":"100%","height":"152px"},attrs:{"src":item.icon,"fit":"cover"}}),_c('div',{staticClass:"style__font"},[_vm._v(_vm._s(item.name))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }